import { BasedB2CTransactionResponseModel } from "app/based/baseApiModel/baseTransactionHistory/basedB2CTransaction/BasedB2CTransactionResponseModel";
import { BasedDetailTransactionResponseModel } from "app/based/baseApiModel/baseTransactionHistory/basedDetailTransaction/BasedDetailTransactionResponseModel";

export class NiceSimRegistrationResponseEntity extends BasedB2CTransactionResponseModel {
  carrier?: string;
  phoneNumber?: string;
  totalPrice?: string | number;
  numberType?: string;
  userFullName?: string;
  userPhone?: string;
  currency?: string;
  buyerPhone?: string;
  buyerName?: string;
  partnerCode?: string;
  partnerName?: string;
  afterCredit?: string;
  beforeCredit?: string;
  supplierRefCode?: string;
  simType?: string | number;

  constructor(data?: Partial<NiceSimRegistrationResponseEntity>) {
    super(data);
    Object.assign(this, data);
  }
}

export class NiceSimRegistrationDetailEntity extends BasedDetailTransactionResponseModel {}
